import classNames from 'classnames'
import * as React from 'react'

import {nth} from '../../../../utils/printCount'
import styles from '../PagerWarning/PagerWarning.css'

interface Props {
  className?: string
  currentPage: number
  total: number
  isLoading?: boolean
  show: boolean
}

function TestScopePagerWarningComponent({className, currentPage, total, isLoading, show}: Props) {
  const content = React.useMemo(() => {
    if (total === 0 && currentPage !== 1) {
      return `There are no test scopes on requested ${nth(
        currentPage,
      )} page. Try going to an earlier page.`
    }

    if (total === 0 && isLoading !== true) {
      return `No test scopes found`
    }

    return null
  }, [currentPage, total, isLoading])
  return show && content != null ? (
    <div className={classNames(className, styles.warning)}>{content}</div>
  ) : null
}

export default React.memo(TestScopePagerWarningComponent)
